import {OutlineContextMenuProvider} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/panels/outline/pages/contextMenu/OutlineContextMenuProvider';
import {ContextMenu} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./OutlineContextMenu.less');
const cx = classnames.bind(styles);

export interface SectionOutlineContextMenuProps
{
    sectionName:string;
    onShow?:() => (void);
    onHide?:() => (void);
}

@observer
export class SectionOutlineContextMenu extends React.Component<SectionOutlineContextMenuProps, any>
{
    render()
    {
        const {sectionName, onShow, onHide} = this.props;
        const dataSource = OutlineContextMenuProvider.sectionsDataSource(sectionName);

        return (
            <div
                className={cx('base')}
            >
                <ContextMenu
                    className={cx('menu')}
                    dataSource={dataSource}
                    useMousePositionAsPopupSource={true}
                    onShow={onShow}
                    onHide={onHide}
                >
                    {this.props.children}
                </ContextMenu>
            </div>
        );
    }
}
